import { TSearchFilter } from '../../filters-advanced/models/advanced-filter.model';
import { TFilters } from '../filters-api/search/quick-filter-service.consts';
import { getDefaultQuickFilters } from './get-default-quick-filters';

export function countActiveQuickFilters(filters: TFilters): number {
  const defaultFilters = getDefaultQuickFilters();

  const activeQuickFilters = filters.quick.filter(
    (filter) => !defaultFilters.some((defaultFilter) => isSameFilter(defaultFilter, filter)),
  );

  return activeQuickFilters.length + filters.advanced.length;
}

export function hasActiveQuickFilters(filters: TFilters): boolean {
  return countActiveQuickFilters(filters) > 0;
}

function isSameFilter(filter: TSearchFilter, otherFilter: TSearchFilter): boolean {
  return (
    filter.keys[0] === otherFilter.keys[0] &&
    filter.operator === otherFilter.operator &&
    haveSameValues(filter.values, otherFilter.values)
  );
}

function haveSameValues(values: unknown[], otherValues: unknown[]): boolean {
  return (
    values.length === otherValues.length &&
    values.every((value) => otherValues.includes(value)) &&
    otherValues.every((value) => values.includes(value))
  );
}
